export default "__VITE_ASSET__DXbzMo5O__"